export default __webpack_public_path__ + "static/media/auth-slide-3.d7778ac7.png";